<template>
  <div>
    <v-list-item @click.stop="campagneDialog = true">
      <v-list-item-content>
        <v-list-item-title
          >Activité : {{ campagne.ll_parcours }}</v-list-item-title
        >

        <v-list-item-subtitle>
          Projet: {{ campagne.ll_programme }}
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action>
        <v-icon color="grey lighten-1">mdi-chevron-right</v-icon>
      </v-list-item-action>
    </v-list-item>

    <v-dialog
      v-model="campagneDialog"
      fullscreen
      hide-overlay
      transition="slide-x-transition"
    >
      <v-card>
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title>
            <v-btn icon @click="campagneDialog = false">
              <v-icon>mdi-arrow-left</v-icon> </v-btn
            >{{ campagne.ll_parcours_effectif }} - {{ campagne.ll_parcours }}
          </v-toolbar-title>
        </v-app-bar>

        <template>
          <v-expansion-panels focusable>
            <v-expansion-panel>
              <v-expansion-panel-header>{{
                campagne.ll_parcours_effectif
              }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container>
                  <v-row>
                    <vcol texte="Projet" :valeur="campagne.ll_programme" />
                    <vcol texte="Groupe" :valeur="campagne.nom_groupe" />
                    <!--   
                  <vcol texte="Suppléant" :valeur="campagne.suppleant" />
                  <vcol texte="Latitude" :valeur="campagne.latitude" />
                  <vcol texte="Longitude" :valeur="campagne.latitude" />
                  <vcol texte="Région" :valeur="campagne.ll_region" />
                  <vcol texte="District" :valeur="campagne.ll_district" />
                  <vcol texte="Commune" :valeur="campagne.ll_commune" />
                  <vcol texte="Fokontany" :valeur="campagne.ll_fokontany" />
                  <vcol texte="Village" :valeur="campagne.village" /> -->
                  </v-row>
                </v-container>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </template>
        <v-card-title>
          Etapes
        </v-card-title>

        <etapesEffectives :parcoursEffectif="campagne" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
  },
  data() {
    return {
      campagneDialog: false,
    };
  },
  props: {
    campagne: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped></style>
